.root {
  align-items: stretch;
  background: var(--color-secondary);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
}

.heading {
  align-items: center;
  display: flex;
  gap: 6px;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
  margin: 0;
  padding: 0 0 0 22px;
}

.row {
  align-items: baseline;
  column-gap: 8px;
  display: grid;
  font-size: 13px;
  grid-template-columns: minmax(80px, max-content) 1fr;
}

.row-label {
  color: var(--color-text-muted, #6b6b6b);
}

.row-value {
  color: var(--color-text, inherit);
  word-break: break-word;
}
